"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _convertHexToRgba = _interopRequireDefault(require("@kiwicom/orbit-design-tokens/lib/convertHexToRgba"));

var _consts = require("../consts");

var _consts2 = require("../../primitives/ButtonPrimitive/common/consts");

var _getButtonTypeToken = _interopRequireDefault(require("./getButtonTypeToken"));

var _opacity;

var opacity = (_opacity = {}, (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.PRIMARY, 15), (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.SECONDARY, 8), (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.CRITICAL, 15), (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.WHITE, 8), (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.PRIMARY_SUBTLE, 8), (0, _defineProperty2.default)(_opacity, _consts.TYPE_OPTIONS.CRITICAL_SUBTLE, 8), _opacity);

var getButtonBoxShadow = function getButtonBoxShadow(state, disabled, theme, type) {
  var wrappedButtonTypeToken = function wrappedButtonTypeToken(name) {
    return (0, _getButtonTypeToken.default)(name, type, theme);
  };

  if (disabled) {
    return null;
  }

  if (state === _consts2.BUTTON_STATES.ACTIVE) {
    return "inset 0 0 6px 3px ".concat((0, _convertHexToRgba.default)(theme.orbit.paletteInkNormal, opacity[type]), ";");
  }

  if (state === _consts2.BUTTON_STATES.FOCUS) {
    return "0 0 0 3px ".concat(wrappedButtonTypeToken(_consts.TOKENS.borderColorButtonFocus));
  }

  return null;
};

var _default = getButtonBoxShadow;
exports.default = _default;